import {setPageInfo} from "../Functions/Helpers";
import React, {useContext} from "react";
import {WooContext} from "../WooContext";

function ProductPerPageOption() {
    const {pagedState} = useContext(WooContext);
    const [paged, setPaged] = pagedState;
    return (
        <div className="products-option">
            <span>Show</span>
            <select value={paged.size} onChange={(e) => {
                e.preventDefault();
                setPaged({size: parseInt(e.target.value), offset: 0});
                setPageInfo(window.location.pathname);
            }}>
                <option value={3}>3</option>
                <option value={6}>6</option>
                <option value={12}>12</option>
                <option value={24}>24</option>
                <option value={36}>36</option>
            </select>
        </div>
    )
}

export default ProductPerPageOption;